import { render, staticRenderFns } from "./ArrecadacaoSala.vue?vue&type=template&id=1c260b04"
import script from "./ArrecadacaoSala.vue?vue&type=script&lang=js"
export * from "./ArrecadacaoSala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports